import { useCallback, useState } from "react";

export type DailyCopyApi = {
    status: string;
    copy: (value: string, what: string) => void;
};

const BLOCKED_COPY = "El navegador no permite copiar aquí: selecciona el texto y cópialo a mano.";

/**
 * Copies an identifier and says what happened in a live region. The clipboard is
 * refused outside secure contexts; the page then says so instead of pretending.
 */
export const useDailyCopy = (): DailyCopyApi => {
    const [status, setStatus] = useState("");

    const copy = useCallback((value: string, what: string): void => {
        const clipboard = typeof navigator === "undefined" ? undefined : navigator.clipboard;
        if (clipboard === undefined || typeof clipboard.writeText !== "function") {
            setStatus(BLOCKED_COPY);
            return;
        }
        clipboard.writeText(value).then(
            () => setStatus(`${what} copiado: ${value}`),
            () => setStatus(BLOCKED_COPY),
        );
    }, []);

    return { status, copy };
};
